export const skinColorPalette1 = `<rect width="40" height="40" rx="4" fill="#F7CE4E"/>`;

export const skinColorPalette2 = `<rect width="40" height="40" rx="4" fill="#F4D4C9"/>`;

export const skinColorPalette3 = `<rect width="40" height="40" rx="4" fill="#E8B09E"/>`;

export const skinColorPalette4 = `<rect width="40" height="40" rx="4" fill="#D9937F"/>`;

export const skinColorPalette5 = `<rect width="40" height="40" rx="4" fill="#DAA378"/>`;

export const skinColorPalette6 = `<rect width="40" height="40" rx="4" fill="#A76D5F"/>`;

export const skinColorPalette7 = `<rect width="40" height="40" rx="4" fill="#8A5C4E"/>`;

export const skinColorPalette8 = `<rect width="40" height="40" rx="4" fill="#5D3F38"/>`;
